import { Grid, NumberInput, Select } from '@mantine/core'
import { UseFormReturnType } from '@mantine/form'
import { TableType } from 'types/products'

type TableSizeValues = {
  tableType: TableType
  width: number
  length: number
}

type Props<Values extends TableSizeValues> = {
  form: UseFormReturnType<Values>
  disabled?: boolean
}

export default function TableSizeInput<Values extends TableSizeValues>({ form, disabled }: Props<Values>) {
  return (
    <>
      <Select
        label="Rodzaj nakrycia stołu"
        description="Obrus, bieżnik lub serwetka"
        placeholder="Wybierz rodzaj"
        allowDeselect={false}
        data={[
          { label: 'Obrus', value: TableType.TABLECLOTH },
          { label: 'Bieżnik', value: TableType.TABLE_RUNNER },
          { label: 'Serwetka', value: TableType.NAPKIN },
        ]}
        withAsterisk
        disabled={disabled}
        {...form.getInputProps('tableType')}
      />
      <Grid>
        <Grid.Col span={6}>
          <NumberInput
            label="Szerokość"
            description="Krótszy bok"
            placeholder="40 cm"
            allowNegative={false}
            allowDecimal={false}
            max={500}
            clampBehavior="strict"
            hideControls
            suffix=" cm"
            withAsterisk
            disabled={disabled}
            {...form.getInputProps('width')}
          />
        </Grid.Col>
        <Grid.Col span={6}>
          <NumberInput
            label="Długość"
            description="Dłuższy bok"
            placeholder="120 cm"
            allowNegative={false}
            allowDecimal={false}
            max={500}
            clampBehavior="strict"
            hideControls
            suffix=" cm"
            withAsterisk
            disabled={disabled}
            {...form.getInputProps('length')}
          />
        </Grid.Col>
      </Grid>
    </>
  )
}
